import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsOptions } from '@onefootprint/fetch-dashboard';
import type { GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsResponse } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { formatAddress, formatDetails, formatName, formatPerson, formatRegistration, formatWatchlist } from '../utils';

// Stable, so each observer formats a response once instead of on every render.
const selectInsights = (response: GetEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsResponse) => {
  const formattedRegistrations = response.registrations.map((filing, index) => formatRegistration(filing, index.toString()));
  return {
    addresses: response.addresses.map((address, index) => formatAddress(address, index.toString())),
    details: formatDetails(response.details),
    names: response.names.map(name => formatName(name, formattedRegistrations)),
    people: response.people.map(person => formatPerson(person)),
    registrations: formattedRegistrations,
    watchlist: formatWatchlist(response.watchlist, response.caAml)
  };
};
const useOnboardingBusinessInsights = (fpBid, onboardingId) => {
  const $ = _c(6);
  let t0;
  if ($[0] !== fpBid || $[1] !== onboardingId) {
    t0 = getEntitiesByFpBidOnboardingsByOnboardingIdBusinessInsightsOptions({
      path: {
        fpBid,
        onboardingId
      }
    });
    $[0] = fpBid;
    $[1] = onboardingId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = Boolean(fpBid) && Boolean(onboardingId);
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = {
      ...t0,
      enabled: t1,
      select: selectInsights
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return useQuery(t2);
};
export default useOnboardingBusinessInsights;